import React, { useEffect, useRef, useState } from 'react'
import PropTypes from 'prop-types'
import { CommunicationPanel, Dropdown } from 'goustouicomponents'
import { filterByDepartment, filterByLocation, extractDepartments } from '../../../utils'
import { pushWindowHistory } from '../../../utils/pushWindowHistory'
import { ContentLoader } from '../../ContentLoader'
import { DepartmentFilters } from '../DepartmentFilters'
import { Jobs } from '../Jobs'
import { NoJobsMessage } from '../NoJobsMessage'
import css from './OpeningsContent.module.css'

const searchParams = new URLSearchParams(window.location.search)

const OpeningsContent = ({ allJobs, isFetchLoading }) => {
  const ref = useRef()
  const [locations, setAllLocations] = useState([])
  const [selectedLocation, setSelectedLocation] = useState(searchParams.get('location'))
  const [selectedDepartment, setSelectedDepartment] = useState(searchParams.get('department'))
  const [jobsToDisplay, setJobsToDisplay] = useState([])
  const [availableDepartments, setAvailableDepartments] = useState([])

  const dropdownLocations = [
    { value: null, text: 'All locations' },
    ...locations.map((location) => ({ value: location, text: location })),
  ]

  useEffect(() => {
    if (allJobs.length) {
      setAllLocations(
        allJobs.reduce((jobLocations, job) => {
          if (jobLocations.includes(job.location.city) || !job.location.city) {
            return jobLocations
          } else {
            return [...jobLocations, job.location.city]
          }
        }, []),
      )
    }
  }, [allJobs])

  useEffect(() => {
    if (allJobs.length) {
      const filteredJobsByLocation = filterByLocation(allJobs, selectedLocation)
      setAvailableDepartments(extractDepartments(filteredJobsByLocation))

      const filteredJobsByDepartment = filterByDepartment(filteredJobsByLocation, selectedDepartment)

      if (!filteredJobsByDepartment.length) {
        setSelectedDepartment(0)
        pushWindowHistory('department')
      }

      setJobsToDisplay(filteredJobsByDepartment)
    }
  }, [allJobs, selectedLocation, selectedDepartment])

  useEffect(() => {
    const scrollToOpeningsIfFilterIsSet = () => {
      setTimeout(() => {
        if (selectedDepartment || selectedLocation) {
          ref.current.scrollIntoView({ behavior: 'smooth' })
        }
      }, 2000)
    }
    scrollToOpeningsIfFilterIsSet()
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  if (isFetchLoading) {
    return <ContentLoader color="Bluecheese" />
  }

  if (!Object.keys(allJobs).length) {
    return <CommunicationPanel level="info" showIcon={false} body={NoJobsMessage} />
  }

  const onChange = ({ value }) => {
    setSelectedLocation(value)
    pushWindowHistory('location', value)
  }

  return (
    <div className={css.openingsWrapper} ref={ref}>
      <div className={css.dropdownWrapper}>
        <div className={css.locationsDropdown}>
          <Dropdown
            name="Locations"
            options={dropdownLocations}
            placeholder={selectedLocation || 'All locations'}
            onChange={onChange}
            className={css.dropdownWrapper}
          />
        </div>
      </div>
      <DepartmentFilters
        departments={availableDepartments}
        setSelectedDepartment={setSelectedDepartment}
        selectedDepartment={selectedDepartment}
      />
      <Jobs jobs={jobsToDisplay} />
    </div>
  )
}

OpeningsContent.propTypes = {
  allJobs: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  isFetchLoading: PropTypes.bool.isRequired,
}

export { OpeningsContent }
